export default __webpack_public_path__ + "assets/japan-flag.png";